<template>
  <wrapper>
    <template slot="navigation">
      <menu-point icon="chevron-left" to="dashboard">Zurück</menu-point>
      <menu-point to="account.details">Stammdaten</menu-point>
      <!--<menu-point to="account.bank">Kontodaten</menu-point>-->
    </template>

    <template slot="page">
      <div v-if="loading" class="flex justify-center items-center h-full">
        <Loading class="h-screen" />
      </div>
      <router-view v-else :organizer="organizer" @saved="loadOrganizer"></router-view>
    </template>
  </wrapper>
</template>

<script>
import accountClient from "@/api/central/account";
import { MenuPoint } from "@/components/Wrapper";
import Wrapper from "@/components/Wrapper";
import Loading from "@/components/Loading";

export default {
  components: {
    MenuPoint,
    Wrapper,
    Loading,
  },

  data() {
    return {
      organizer: {},
      loading: true,
    };
  },

  mounted() {
    this.loadOrganizer();
  },

  methods: {
    loadOrganizer() {
      this.loading = true;
      this.organizer = accountClient
        .show()
        .then((response) => (this.organizer = response.data.data))
        .then(() => (this.loading = false));
    },
  },
};
</script>
